const popOnPop = {
    show:false
};

export default popOnPop;